import React from "react";
import styled from "@emotion/styled";
import { PublicMember } from "types/public";
import StaffCard from "contents/staff/StaffCard";
import { useNavigate } from "react-router-dom";
import DisplayType from "utils/displayType";
import "animate.css/animate.min.css";

export interface TeamSectionProps {
  teamId?: string;
  name?: string;
  description?: string;
  members: PublicMember[];
}

interface Props {
  item: TeamSectionProps;
}

const TeamSectionDepth1: React.FC<Props> = (props) => {
  const navigation = useNavigate();
  const mode = DisplayType();
  const { item } = props;

  return (
    <Container>
      <div className="section__list">
        <Section>
          <div
            className={`team__section__title ${
              mode === "Mobile" ? "font-sub-title2" : "font-sub-title"
            }`}
          >
            {item.name}
          </div>
          <div
            className={`team__section__description ${
              mode === "Mobile" ? "font-body3" : "font-body2"
            }`}
          >
            {item.description}
          </div>
          <div className="team__list">
            {item.members
              .filter(
                (member) =>
                  member.profile_image && member.profile_image.length > 0
              )
              .map((member) => {
                return (
                  <StaffCard
                    key={member.id}
                    member={member}
                    onClick={() => {
                      navigation(`/staff/${member.id}`);
                    }}
                  />
                );
              })}
          </div>
        </Section>
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .team__section__title {
    color: var(--black);
    text-transform: uppercase;
  }
  .section__list {
    display: flex;
    flex-direction: column;
    gap: 60px;
    padding-top: 40px;
  }

  @media only screen and (max-width: 768px) {
    .section__list {
      padding-top: 24px;
      gap: 80px;
    }
  }
`;

const Section = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  .section__team__sub__title {
    color: var(--grey-60);
    text-transform: uppercase;
  }
  .team__section__description {
    color: var(--grey-60);
    margin-top: 8px;
  }
  .team__list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 24px;
    margin-top: 24px;
  }

  @media only screen and (max-width: 768px) {
    .team__section__description {
      color: var(--grey-60);
      margin-top: 8px;
    }

    .team__list {
      column-gap: 3px;
      row-gap: 24px;
      margin-top: 24px;
    }
  }
`;

export default React.memo(TeamSectionDepth1);
